<script>

export default {
  // ... existing data, methods, etc.
  computed: {
    currentYear() {
      return new Date().getFullYear(); // e.g., 2025
    }
  }
};

</script>


<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          &copy; {{currentYear}} Head of Service
        </div>
        <div class="col-sm-6">
          <div class="text-sm-right d-none d-sm-block">
            Powered by Connexxion Telecoms
<!--            <i class="mdi mdi-heart text-danger"></i>-->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>